// Mock data for Mara Martins Portfolio

export const personalInfo = {
  name: "Mara Martins",
  title: "AI Localization Strategist & Program Leader",
  tagline: "Bridging AI with language, culture, and technology to help global companies expand with confidence and impact.",
  bio: "With 15+ years in localization, I bring a blend of program management, marketing expertise, and AI innovation — always with a focus on empowering teams and mentoring the next generation of leaders. I'm located in Mountain View, California, USA.",
  email: "marapt@gmail.com",
  location: "Mountain View, California, USA",
  // Mara's actual GitHub profile photo
  photo: "https://avatars.githubusercontent.com/u/233815337?v=4",
  linkedin: "https://linkedin.com/in/maramartinspt",
  github: "https://github.com/marapt",
  calendly: "https://calendly.com/maramartins"
};

export const companies = [
  { name: "HP", logo: "https://maramartins.com/wp-content/uploads/2025/09/Screen-Shot-2025-09-17-at-10.48.43-AM-1024x215.png" },
  { name: "Square", logo: "https://maramartins.com/wp-content/uploads/2025/09/Square_Logo_2025_Black-1024x257.png" },
  { name: "LinkedIn", logo: "https://maramartins.com/wp-content/uploads/2025/09/LI-Logo-1024x250.png" },
  { name: "Infoblox", logo: "https://maramartins.com/wp-content/uploads/2025/09/Screen-Shot-2025-09-17-at-10.50.03-AM.png" },
  { name: "Apple", logo: "https://maramartins.com/wp-content/uploads/2025/09/apple-logo.png" },
  { name: "Welocalize", logo: "https://maramartins.com/wp-content/uploads/2025/09/Screen-Shot-2025-09-17-at-11.58.54-AM-1.png" },
  { name: "VMware", logo: "https://maramartins.com/wp-content/uploads/2025/09/Screen-Shot-2025-09-17-at-11.05.49-AM-3.png" }
];

export const services = [
  {
    id: 1,
    title: "AI Localization",
    description: "Smarter, faster global reach with AI. Leveraging cutting-edge machine learning and neural translation technologies to deliver high-quality localized content at scale.",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Program Management",
    description: "Clear plans, seamless execution. End-to-end localization program management with proven methodologies that ensure on-time, on-budget delivery.",
    icon: "Target"
  },
  {
    id: 3,
    title: "Translation",
    description: "Accurate words, trusted connections. Professional translation services that capture nuance, tone, and cultural context for authentic global communication.",
    icon: "Languages"
  },
  {
    id: 4,
    title: "Training",
    description: "Practical skills for real-world success. Customized training programs that empower teams with localization best practices and emerging technologies.",
    icon: "GraduationCap"
  }
];

export const projects = [
  {
    id: 1,
    title: "AI Polyglots",
    description: "Break every language barrier. Everywhere. An experimental platform that allows you to communicate across language barriers using text, voice, sign language, and more.",
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop",
    tags: ["AI", "Translation", "Accessibility"],
    link: "https://aipolyglots.com/",
    featured: true
  },
  {
    id: 2,
    title: "Global Marketing Localization",
    description: "Led end-to-end localization of marketing campaigns across 40+ languages for a Fortune 500 tech company.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
    tags: ["Marketing", "Localization", "Strategy"],
    link: null,
    featured: false
  },
  {
    id: 3,
    title: "AI Translation Engine",
    description: "Implemented and optimized neural machine translation workflows, reducing time-to-market by 60%.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop",
    tags: ["AI", "NMT", "Optimization"],
    link: null,
    featured: false
  },
  {
    id: 4,
    title: "Localization Training Program",
    description: "Developed comprehensive training curriculum adopted by multiple enterprise clients worldwide.",
    image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&h=400&fit=crop",
    tags: ["Training", "Education", "L10n"],
    link: null,
    featured: false
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Mara is one of the best program leads I have ever worked with. She is highly strategic yet also has an incredible eye for details… Her ability to plan and execute localization programs is second to none.",
    author: "Justin Mounts",
    role: "Global Marketing Executive",
    company: "Former HP, Infoblox"
  },
  {
    id: 2,
    quote: "Mara is an extremely effective communicator… She consistently goes above and beyond managing people and always challenging her team to work to the best of their potential.",
    author: "Ernesto Cabanes",
    role: "Globalization Lead",
    company: "Square"
  },
  {
    id: 3,
    quote: "Mara managed the translation engine for Infoblox… whipped the external agency into shape and developed a clear approval and delivery process… effectively reduced the timeline to market significantly.",
    author: "Nghia Karoll, MBA",
    role: "Sr. Director, Integrated Campaigns & Demand Gen",
    company: "Infoblox"
  },
  {
    id: 4,
    quote: "Mara has a solid understanding and experience in supporting international markets with software and online content. She possesses strong communication and collaboration skills.",
    author: "Agustín Da Fieno Delucchi",
    role: "Global Technology Leader",
    company: "Enterprise Tech"
  }
];

export const stats = [
  { value: "15+", label: "Years Experience" },
  { value: "40+", label: "Languages" },
  { value: "50+", label: "Global Projects" },
  { value: "100%", label: "Client Satisfaction" }
];
